<template>
    <div class="home">
      <div class="none flex_column_center" v-show="showNone">
        <img src="../assets/img/none.png" alt="">
        <p class="tips">{{$t('request.homeNone')}}</p>
      </div>
      <div v-show="!showNone" class="flex_center content">
        <el-skeleton style="width: 240px;height:400px;" :count="1" :rows="1" animated  :loading="loading">
        <div class="left box flex_only_center">
            <p class="title" style="width:280px;">{{$t('home.selectBrand')}}</p>
            <div class="list flex_column_align_center">
                <div @click="handleBrand(item)" class="logo  flex_column_align_center" v-for="(item,index) in brandList" :key="index">
                    <img :src="item.carBrandLogo" alt="">
                    <!-- <p>{{item.carBrandName}}</p> -->
                    <!-- <el-divider></el-divider> -->
                </div>
            </div>
        </div>
        </el-skeleton>

        <div class="arrow flex_default_center"><i class="el-icon-arrow-right"></i></div>
        <el-skeleton class="model-skeleton" style="width:70%;height:400px;" :count="1" :rows="1" animated  :loading="loading">
        <div class="right box flex_only_center">
            <p class="title">{{$t('home.selectModel')}}</p>
            <div class="list">
              <div class="model flex_column_align_center" @click="handleModel(item)" v-for="(item,index) in modelList" :key="index">
                <div class="model_img flex_default_center"><img :src="item.carModelPic" alt=""></div>
                <p>{{item.carModelName}}</p>
              </div>
            </div>
        </div>
         </el-skeleton>
    </div>
      </div>

</template>
<script>
import { getHomeBrand } from '@/api/api'

export default {
  data () {
    return {
      brandList: [],
      modelList: [],
      currentBrand:'',
      showNone:false,
      loading:true
    }
  },
  watch: {
    '$i18n.locale'(newValue, oldValue) {
      this.getBrand()
    },
  },
  mounted(){
    if(localStorage.getItem('lang')){
      this.$i18n.locale = localStorage.getItem('lang')
    }

    this.getBrand()
  },
  methods:{

    // 点击品牌获取车型
    handleBrand(data){
      this.currentBrand = data.carBrandName
      // console.log(this.currentBrand)
      // this.getBrand()

      this.modelList = data.modelList
    },
    // 点击车型跳转预览
    async handleModel(data){
      // let lang = this.$i18n.locale
      // let nowLang
      // if(lang=='zh')nowLang=0
      // if(lang=='en')nowLang=1
      // if(lang=='ru')nowLang=2
      // if(lang=='fa')nowLang=3
      this.$router.push({name:'part',query:{brand:this.currentBrand,model:data.carModelName}})
      // ${data.id}`, query: data
      sessionStorage.setItem('carModelId',data.carModelId)
      // sessionStorage.setItem('lang',nowLang)
    },
    // 获取品牌 车型
    async getBrand(){
      this.loading = true
      this.showNone = false
      let lang = this.$i18n.locale
      let nowLang
      if(lang=='zh')nowLang=0
      if(lang=='en')nowLang=1
      if(lang=='ru')nowLang=2
      if(lang=='fa')nowLang=3
      if(lang=='vi')nowLang=4
      if(lang=='es')nowLang=5
      let query = {
        data: {
          // carBrandId: this.currentBrand
          language:nowLang
        },
        page: {
          pageNum: 1,
          pageSize: 20
        }
      }
      const res = await getHomeBrand(query)
      // console.log(res)

      if(res.status==0){
        if(res.data.brandList.length>0){

            this.brandList = res.data.brandList
            this.modelList = this.brandList[0].modelList
            this.currentBrand = res.data.brandList[0].carBrandName
            this.loading = false
            this.showNone = false
            this.$store.state.isNone = false
        }else{
          this.loading = false
          this.brandList = []
          this.modelList = []
          this.showNone = true
          this.$store.state.isNone = false
        }

      }
    }
  }
}
</script>
<style lang="scss" scoped>
.home{
  ::v-deep .el-skeleton__p.is-first {
    margin-top: 30px;
    margin-left: 20px;
    width: 200px!important;

  }
  ::v-deep .el-skeleton__item{
    height: 400px;
  }
  .content{
    padding: 0 40px;
  }
  .model-skeleton{
      ::v-deep .el-skeleton__p.is-first {
        margin-top: 30px;
        margin-left: 0px;
        width: 70%!important;

      }
  }
    .none{
      padding-top: 90px;
      img{
        width: 300px;
      }
      p{
        font-size: 20px;
      }
    }
    .box{

        .title{
            // font-family: SourceHanSansSC;
            font-weight: 400;
            font-size: 18px;
            color: rgb(16, 16, 16);
            font-style: normal;
            letter-spacing: 0px;
            line-height: 26px;
            text-decoration: none;
            text-shadow: rgb(189, 49, 36) 0px 2px 6px;
            margin: 10px auto 20px auto;
        }
        .list{
            border-radius: 5px;
            height: 400px;
            box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 6px 2px;
        }
    }
    .left{
      margin-left: 20px;
      width: 200px;
        .list{
            padding: 5px;
            overflow-y: scroll;
            box-sizing: border-box;
            .logo{
              // flex-shrink:0;
                width: 180px;
                border-bottom: 1px solid #eee;
                cursor: pointer;
                height: 140px;
                box-sizing: border-box;
                img{
                    width: 100%;
                    height: 130px;
                    // height: 100px;
                    object-fit: cover;
                }
                p{
                    font-size: 14px;
                    line-height: 30px;
                    color: rgba(189,49,36,1);
                }
                .el-divider--horizontal{
                  margin: 10px 0;
                }
            }
            img:hover {
              border: 1px solid rgb(189, 49, 36);
              box-shadow: rgb(189, 49, 36) 0px 2px 6px 0px;
            }
        }
        .list::-webkit-scrollbar {
          width: 4px;
        }
        .list::-webkit-scrollbar-thumb {
          border-radius: 10px;
          -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          opacity: 0.2;
          background: rgba($color: #d7d6d6, $alpha: 0.8);
        }
        .list::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          border-radius: 0;
          background: rgba($color: #eeeeee, $alpha: 0.8);
        }

    }

    .arrow{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        // background: #000;
        margin: 0 20px;
        i{
            color: #333;
        }
    }

    .right{
       width: 70%;

       .list{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        // flex-wrap: wrap;
        padding: 10px;

        box-sizing: border-box;
        // justify-content: space-around;
        .model{
          width: 200px;
          height: 210px;
          border: 1px solid #d2d2d2;
          border-radius: 3px;
          overflow: hidden;
          .model_img{
            width: 100%;
            height: 190px;
            object-fit: cover;
            overflow: hidden;
            img{
              width: 100%;
              height: 100%;
            }
          }
          p{
            font-size: 14px;
            line-height: 30px;
          }
        }
        .model:hover{
            border: 1px solid rgb(189, 49, 36);
            box-shadow: rgb(189, 49, 36) 0px 2px 6px 0px;
            p{
              color: rgb(189, 49, 36);
            }
        }
       }
    }
}
</style>
